<div class="clausulas-modal">
  <button class="btn close-modal" (click)="activeModal.dismiss()">
    <i class="fas fa-times"></i>
  </button>
  <div class="d-flex justify-content-center">
    <h4>{{title}}</h4>
  </div>
  @if (showMessage) {
    <ngb-alert class="mt-4" type="success" [dismissible]="false">Campo copiado al portapapeles
    </ngb-alert>
  }
  <div class="col-lg-9 mx-auto pt-4">
    <button class="btn btn-outline-primary bg-white rounded-pill text-dark mb-3 px-3 font-weight-bold" (click)="createCustomfields()">
      <i class="fas fa-plus"></i> Crear
    </button>
    @for (item of dynamicfield; track item; let i = $index) {
      <div
        class="list-group-item list-group-item-action version-list-item">
        <div class="row">
          <div class="col-8 p-2 ">Nombre: {{item.name}}</div>
          <div class="col-4">
            <div class="row">
              <div class="col-6 p-2">
                <button class="btn white-button btn-block" (click)="removeNewCustomField(item)"><i
                class="fas fa-trash"></i></button>
              </div>
              <div class="col-6 p-2">
                <button class="btn white-button btn-block" (click)="copy(item)"><i class="fas fa-copy"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showMessageArray == true) {
      <div>
        No se encontraron campos.
      </div>
    }
  </div>
  <div class="d-flex justify-content-center">
    @if (emptyButton && statusModal === false) {
      <button class="mx-2 round-button-green"
        (click)="activeModal.close({subject: undefined, parent: undefined})">
        {{emptyButton}}
      </button>
    }
    @if (statusModal === false) {
      <button class="mx-2 round-button" (click)="aceppt()">
        Aceptar
      </button>
    }
    @if (statusModal && emptyButton) {
      <button class="mx-2 round-button-green" (click)="confirm(true)">
        {{emptyButton}}
      </button>
    }
    @if (statusModal) {
      <button class="mx-2 round-button" (click)="confirm(false)">
        Aceptar
      </button>
    }

  </div>
</div>